var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"adminUser"}},[[_c('AdminNewNavbar',{attrs:{"status":_vm.status}}),_c('div',{staticClass:"adminUserPanel"},[_vm._m(0),_c('div',{staticClass:"admin-user-card"},_vm._l((_vm.users),function(user){return _c('AdminUserCard',{key:user.id,attrs:{"user":user}})}),1)])]],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('h1',[_vm._v("使用者列表")])])
}]

export { render, staticRenderFns }